import { useEffect } from 'react';

function upsertMeta(attr, key, content) {
  if (!content) return;
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function useSeo({
  title,
  description,
  path = '/',
  noindex = false,
  image,
  imageAlt,
  locale = 'en_US',
  keywords,
}) {
  useEffect(() => {
    const siteName = 'TheScandal';
    const fullTitle = title ? `${title} | ${siteName}` : siteName;
    const base = process.env.REACT_APP_SITE_URL || window.location.origin;
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const canonical = `${base}${normalizedPath}`;
    const defaultImage = `${base}/fav.png`;
    const resolvedImage = image || defaultImage;
    const resolvedImageAlt = imageAlt || `${siteName} preview image`;
    const resolvedKeywords = Array.isArray(keywords)
      ? keywords.join(', ')
      : (keywords || 'community updates platform, anonymous reporting platform, local incident alerts, whistleblower tips, real-time awareness, anonymous posts');

    document.title = fullTitle;

    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', resolvedKeywords);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:site_name', siteName);
    upsertMeta('property', 'og:locale', locale);
    upsertMeta('property', 'og:image', resolvedImage);
    upsertMeta('property', 'og:image:alt', resolvedImageAlt);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', resolvedImage);
    upsertMeta('name', 'twitter:image:alt', resolvedImageAlt);

    upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    upsertLink('canonical', canonical);
  }, [title, description, path, noindex, image, imageAlt, locale, keywords]);
}
